<script setup lang="ts">
import type { HTMLAttributes } from "vue"
import { DialogOverlay } from "reka-ui"
import { cn } from "@/shared/lib/utils"

// Лише `class` і forward-имо — тип звужений до реально проброшуваного пропа
// (не обіцяємо DialogOverlayProps, які нікуди не йдуть).
const props = defineProps<{ class?: HTMLAttributes["class"] }>()
</script>

<template>
  <DialogOverlay
    data-slot="sheet-overlay"
    :class="
      cn(
        // Scrim навмисно theme-independent (фіксований чорний з прозорістю) —
        // окремого `--overlay`-токена в DS немає (флагнуто в tech-036).
        'fixed inset-0 z-50 bg-black/50',
        props.class,
      )
    "
  >
    <slot />
  </DialogOverlay>
</template>

<style scoped>
/*
 * Fade-анімація backdrop через reka data-state. Tailwind-animate плагіна в проєкті
 * нема (alert-dialog/dropdown без анімацій), а для bottom-sheet рух — частина UX,
 * тож тримаємо keyframes локально в примітиві (без залежності, без правки globals).
 * Presence reka тримає вузол під час exit, поки програється `closed`-анімація.
 */
[data-slot="sheet-overlay"][data-state="open"] {
  animation: sheet-overlay-in 200ms ease-out;
}

[data-slot="sheet-overlay"][data-state="closed"] {
  animation: sheet-overlay-out 200ms ease-in;
}

@keyframes sheet-overlay-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes sheet-overlay-out {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  [data-slot="sheet-overlay"][data-state="open"],
  [data-slot="sheet-overlay"][data-state="closed"] {
    animation-duration: 1ms;
  }
}
</style>
